<template>
  <v-layout>
      <v-flex>                    
        <v-data-table
        :headers="headers"
        :items="tipocambio"        
        :search="search"
        class="elevation-1"
        >
        <template v-slot:item.activo="{ item }">  
            <div v-if="item.activo  ">
                <span class="blue--text">Activo</span>
                
            </div>
            <div v-else>
                <span class="red--text">Inactivo</span>                
            </div>                  
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Tipo de Cambio</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer> 
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                    </template>
                    <v-card>
                    <v-card-title>
                        <span class="headline" style="color: #3F51B5;">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field type="number" v-model="tipoc" label="Tipo de cambio"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-select v-model="idmonedas" :items="monedas" label="Monedas">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                     <v-menu
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="date"
                                            label="Vigencia"
                                            prepend-icon="today"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker
                                        v-model="date"
                                        @input="menu2 = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog  v-model="adModal" max-width="290px">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Puerto?</v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Puerto?</v-card-title>
                        <v-card-text>
                            Estás a punto de
                            <span v-if="adAccion==1">Activar</span>
                            <span v-if="adAccion==2">Desactivar</span>
                            el item {{ adNombre }}
                        </v-card-text>
                        <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                 Cancelar
                             </v-btn>
                             <v-btn v-if="adAccion==1" color="orange darken1" text="text" @click="activar">
                                 Aceptar
                             </v-btn>
                             <v-btn v-if="adAccion==2" color="orange darken1" text="text" @click="desactivar">
                                 Desactivar
                             </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.opciones="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            edit
            </v-icon>
            <template v-if="item.activo">                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(2,item)"
                    >
                    block
                    </v-icon>                               
            </template>
            <template v-else>                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(1,item)"
                    >
                    check
                    </v-icon>                               
            </template> 
        </template>   
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                        
      </v-flex>
  </v-layout>
</template>
<script>
import axios from 'axios'      
export default {
    data(){
        return{
            tipocambio:[],
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false,align:'center' },                            
                { text: 'Monea', value: 'moneda',align:'center' },
                { text: 'Tipo de Cambio', value: 'tipodecambio', sortable: false,align:'center' }, 
                { text: 'Vigencia', value: 'nvigencia',align:'center' },
                { text: 'Estado', value: 'activo',align:'center' },
            ],
            puertos:[], 
            adModal:false,            
            dialog: false,
            search:'',
            editedIndex: -1,              
            id:'',
            idpais:'',
            idpuerto:'',
            paises:[],
            codigo:'',
            nombre:'',
            descripcion:'',                
            valida:'',
            validaMensaje:[],                
            adAccion:0,
            adNombre:'',
            adId:'',
            monedas:[],
            modal: false,
            menu2: false,
            /********************/
            tipoc:'',
            idmonedas:'',
            date:'',
            idtc:0,
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'Nuevo Tipo de Cambio' : 'Actualizar Tipo de Cambio'
        },
    },
    created () {        
        this.listar();
        this.select();
    },
    methods:{
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            console.log('Listar')
            axios.get('api/Tipocambios/Listar',configuracion).then(function(response){
              me.tipocambio=response.data;
              console.log('me.tipocambio')
              console.log(me.tipocambio)
            }).catch(function(error){
              console.log(error);
            });
        },
        select(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var paisesArray=[];
            var monedasArray=[];
            axios.get('api/Paises/Select',configuracion).then(function(response){
              paisesArray=response.data;
              paisesArray.map(function(x){
                  me.paises.push({text:x.nombre,value:x.idpais});
              });            
            }).catch(function(error){
              console.log(error);
            });
            axios.get('api/Monedas/SelectT',configuracion).then(function(response){            
                monedasArray=response.data;
                monedasArray.map(function(x){
                    me.monedas.push({text:x.abreviatura,value:x.idmoneda});
                });            
            }).catch(function(error){
                console.log(error);
            }); 
        },
        guardar () {
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;    
            if (this.editedIndex > -1) {//codigo para editar            
                            console.log('Actualizndo')
                            console.log(me.idtc)
                            console.log(me.idmonedas)
                            console.log(me.tipoc)
                            console.log(me.date)
                axios.put('api/Tipocambios/Actualizar',{
                    'idtipocambio':me.idtc,
                    'idmoneda':me.idmonedas,
                    'tipodecambio':me.tipoc,
                    'vigencia':me.date
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                }).catch(function(error){
                    console.log(error);
                });  
            }else{//codigo para guardar
                axios.post('api/Tipocambios/Crear',{
                    'idmoneda':me.idmonedas,
                    'tipodecambio':me.tipoc,
                    'vigencia':me.date
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                }).catch(function(error){
                    console.log(error);
                });                
            }            
        },
        editItem (item) {
            this.idmonedas = item.idmoneda;
            this.tipoc = item.tipodecambio;
            this.date = item.vigencia;
            this.idtc = item.idtipocambio;
            this.editedIndex=1;
            this.dialog = true
        },
        activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idpuerto;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
        },
        activarDesactivarCerrar(){
            this.adModal=false;
        },
        close () {
            this.dialog = false;            
            //this.limpiar();
        },
    }
}
</script>